module.exports = __webpack_public_path__ + "img/view-all-icon.4d8b86d5.svg";